import React from "react";
import { Row, Col, Space, Statistic, Typography } from "antd";
import {
  FileTextOutlined,
  UserOutlined,
  IdcardOutlined,
} from "@ant-design/icons";
import THEME from "../theme";

const { Title, Text } = Typography;

const ContractHeader = ({
  judgeData,
  loanData,
  memoDataOld,
  searchData,
  rejudgeData,
}) => {
  const customer = loanData?.CUSTOMER;

  const FLAG_CONFIG = {
    1: {
      background: "#f6ffed",
      border: "1px solid #b7eb8f",
      label: "ทำยอม",
      badgeColor: "#389e0d",
      badgeBg: "#d9f7be",
    },
    2: {
      background: "#fff2f0",
      border: "1px solid #ffccc7",
      label: "พิพากษา",
      badgeColor: "#cf1322",
      badgeBg: "#ffebe8",
    },
    judgeDue: {
      background: "#f9f0ff",
      border: "1px solid #d3adf7",
      label: "พิพากษา มีดิว",
      badgeColor: "#531dab",
      badgeBg: "#efdbff",
    },
    6: {
      background: "#fff2f0",
      border: "1px solid #ffccc7",
      label: "(ส่วนต่าง)",
      badgeColor: "#cf1322",
      badgeBg: "#ffebe8",
    },
  };

  const flagStyle = judgeData?.flagLoanNew
    ? judgeData?.flagLoanNew === 2 && judgeData?.loanJudge
      ? FLAG_CONFIG.judgeDue
      : (FLAG_CONFIG[judgeData?.loanJudge] ?? FLAG_CONFIG[1])
    : "";
  const lawStyle = judgeData?.judge?.[0]?.LAW_TYPE_ID === 6 && FLAG_CONFIG[6];
  let contnoOld;
  let contnoNew;
  let flagContno = false;

  if (searchData.CONTNO === judgeData?.currentNewContno) {
    contnoOld = judgeData?.judge?.[0]?.CONTNO;
    contnoNew = judgeData?.judge?.[0]?.newContno;
    flagContno = true;
  } else if (judgeData?.rejudge_from_id_judge) {
    contnoOld = rejudgeData?.judge?.[0]?.CONTNO;
    contnoNew = rejudgeData?.judge?.[0]?.newContno;
    flagContno = true;
  } else {
    contnoOld = judgeData?.CONTNO || searchData.CONTNO;
  }

  return (
    <div
      style={{
        background: THEME.gradient,
        padding: "24px 32px",
        borderRadius: THEME.borderRadius,
        marginBottom: 24,
        color: "#fff",
      }}
    >
      <Row gutter={[24, 16]} align="middle">
        <Col xs={24} md={16}>
          <Space direction="vertical" size={4}>
            <Title level={3} style={{ color: "#fff", margin: "8px 0" }}>
              <FileTextOutlined style={{ marginRight: 12 }} />
              {(contnoOld ? contnoOld : "") +
                (contnoNew ? " ➡️ " + contnoNew : "")}{" "}
              {flagContno && (
                <span
                  style={{
                    background: flagStyle.badgeBg,
                    color: flagStyle.badgeColor,
                    borderRadius: 20,
                    padding: "2px 10px",
                    fontSize: 20,
                    fontWeight: 500,
                  }}
                >
                  {" "}
                  {flagStyle.label}
                  {lawStyle.label}
                </span>
              )}
            </Title>
            <Space size="large">
              <Text copyable style={{ color: "rgba(255,255,255,0.85)" }}>
                <UserOutlined style={{ marginRight: 6 }} />
                {customer?.SNAM}
                {customer?.NAME1} {customer?.NAME2}
              </Text>
              <Text copyable style={{ color: "rgba(255,255,255,0.85)" }}>
                <IdcardOutlined style={{ marginRight: 6 }} />
                {customer?.CUSCOD}
              </Text>
            </Space>
          </Space>
        </Col>

        <Col xs={24} md={8} style={{ textAlign: "right" }}>
          <Statistic
            title={
              <Text style={{ color: "rgba(255,255,255,0.7)" }}>สถานะสัญญา</Text>
            }
            value={
              judgeData?.judge?.[0]?.statusDescription === "ปิดบัญชี"
                ? "ปิดสัญญา"
                : judgeData?.ACTIVE || judgeData?.judge?.length > 0
                  ? judgeData?.enforcement?.latest?.receiveByName &&
                    !judgeData?.enforcement?.latest?.cancelDate
                    ? `ส่งบังคับคดี → (${judgeData?.enforcement?.latest?.receiveByName})`
                    : judgeData?.judge?.length > 0 &&
                        judgeData?.currentNewContno === searchData.CONTNO
                      ? `${judgeData?.judge?.[0]?.statusDescription} ${judgeData?.judge?.[0]?.currentStatus > 10 ? (judgeData?.judge?.[0]?.SDATE ? "(เป็นสัญญาแล้ว)" : "(ยังไม่อนุมัติสัญญา)") : ""} `
                      : judgeData?.currentNewContno !== searchData.CONTNO &&
                          judgeData?.rejudge_from_id_judge
                        ? "สัญญาถูกรีไฟแนนซ์"
                        : judgeData?.statusDescription || "ปิดสัญญา"
                  : !judgeData?.ACTIVE
                    ? !judgeData?.ACTIVE && judgeData?.currentStatus === 18
                      ? "ปิดสัญญา(เกิดสัญญาใหม่)"
                      : judgeData?.details
                        ? judgeData?.details
                        : "ปิดสัญญา"
                    : "ไม่มีสถานะ"
            }
            valueStyle={{ color: "#fff", fontSize: 28 }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ContractHeader;
